import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  // body {
  //   background-color: ${({ theme }) => theme.colors.neutral[100]};
  //   color: ${({ theme }) => theme.colors.neutral[900]};
  //   line-height: ${({ theme }) => theme.lineHeights.normal};
  // }

  button {
    font-family: inherit;
    font-size: inherit;
    cursor: pointer;
  }

  input, select, textarea {
    font-family: inherit;
    font-size: inherit;
  }

  a {
    color: ${({ theme }) => theme.colors.primary[600]};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: ${({ theme }) => theme.lineHeights.tight};
  }
`; 